export const APP_TITLE = 'TCO One Portfolio';

// Keys are full route patterns; '*/<rest>' entries match shared child routes
// (e.g. the add/edit project form) mounted under several parent routes.
export const ROUTE_TITLE_KEYS: Record<string, string> = {
  'not-allowed': 'PAGE_TITLES.NOT_ALLOWED',
  initiatives: 'PAGE_TITLES.PORTFOLIO',
  'portfolio-backlogs': 'PAGE_TITLES.PORTFOLIO_BACKLOG',
  myportfolio: 'PAGE_TITLES.MY_PORTFOLIO',
  approvals: 'PAGE_TITLES.MY_APPROVALS',
  manpower: 'PAGE_TITLES.MANPOWER',
  'manpower/job-log': 'PAGE_TITLES.JOB_LOG',
  'manpower/job-log-detail': 'PAGE_TITLES.JOB_LOG_DETAIL',
  mybreakinoutapprovals: 'PAGE_TITLES.BREAK_IN_OUT_APPROVALS',
  'mybreakinoutapprovals/break-in-out-details': 'PAGE_TITLES.BREAK_IN_OUT_DETAILS',
  newprojectsbreakin: 'PAGE_TITLES.NEW_PROJECTS_BREAK_IN',
  cutline: 'PAGE_TITLES.MEJ_CUT_LINE',
  'cutline/scenarios': 'PAGE_TITLES.CUTLINE_SCENARIOS',
  'cutline/playground': 'PAGE_TITLES.CUTLINE_PLAYGROUND',
  'cutline/budget-change': 'PAGE_TITLES.CUTLINE_BUDGET_CHANGE',
  'cutline/tfm-cutline': 'PAGE_TITLES.TFM_CUTLINE',
  forecasts: 'PAGE_TITLES.FORECAST',
  'forecasts/revisions': 'PAGE_TITLES.FORECAST_REVISIONS',
  'forecasts/plan-vs-fact': 'PAGE_TITLES.FORECAST_PLAN_VS_FACT',
  'forecasts/detail-forecast': 'PAGE_TITLES.FORECAST_DETAIL',
  'capex/capex-prioritization': 'PAGE_TITLES.CAPEX_PRIORITIZATION',
  heatmap: 'PAGE_TITLES.HEAT_MAP',
  'heatmap/editor': 'PAGE_TITLES.HEAT_MAP_EDITOR',
  'linked-records': 'PAGE_TITLES.REPORTS_EWR',
  'linked-records/edit/:type/:id': 'PAGE_TITLES.LINKED_RECORD_EDIT',
  dashboard: 'PAGE_TITLES.DASHBOARD',
  settings: 'PAGE_TITLES.SETTINGS',
  '*/add': 'PAGE_TITLES.ADD_PROJECT',
  '*/edit/:id': 'PAGE_TITLES.EDIT_PROJECT',
  '*/edit/:id/break-in-out-details': 'PAGE_TITLES.BREAK_IN_OUT_DETAILS',
};
